import React from "react";
import makeStyles from "@mui/styles/makeStyles";

import { Link, useLocation, useResolvedPath } from "react-router-dom";
import clsx from "clsx";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CreatorHeaderLogo from "./CreatorHeaderLogo";

const useStyles = makeStyles(theme => ({
  home: {
    height: 44,
    width: 44,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    textAlign: "center",
    borderRadius: 12,
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.contrastText,
    "&:hover": {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
  },

  placeholder: {
    width: 44,
    height: 44,
  },

  selectedTab: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.contrastText,
    },
  },

  homeIcon: {
    fontSize: "2.2rem",
  },
}));

const CreatorNavigation = () => {
  const url = useResolvedPath(".").pathname;
  const location = useLocation();
  const classes = useStyles();

  const tabs = {
    home: `${url}/home`,
  };

  return (
    <Box>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item>
          {location.pathname !== "/creator/home" ? (
            <Link role="tab" to={tabs.home}>
              <Box
                className={clsx(classes.home, {
                  [classes.selectedTab]: location.pathname.startsWith(
                    tabs.home,
                  ),
                })}
              >
                <DashboardIcon
                  fontSize="large"
                  classes={{ fontSizeLarge: classes.homeIcon }}
                />
              </Box>
            </Link>
          ) : (
            <Box className={classes.placeholder} />
          )}
        </Grid>

        <Grid item sm>
          <CreatorHeaderLogo />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CreatorNavigation;
